module.exports = __webpack_public_path__ + "static/b2b_header-c0dea439fc5c9d5233ab9b455cec45db.png";